module.exports = __webpack_public_path__ + "static/media/glass-martini-alt.11c8049b.svg";